import styled from "styled-components";
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > div:first-child {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  > div span {
    color: ${({ theme, isInverted }) => isInverted ? theme.colors.white : theme.colors.grey13};
    font-size: ${({ theme }) => theme.fontTokens.font13[0]};
    line-height: ${({ theme }) => theme.fontTokens.font13[1]};
    margin-bottom: 0.25rem;
    margin-right: 0.25rem;
  }
`;
export const StyledProgressBar = styled.div `
  width: 100%;
  ${({ size }) => (size === "S" ? `height: 0.25rem` : `height: 0.5rem`)};
  ${({ theme, isInverted }) => isInverted
    ? `background-color:rgba(${theme.colors.transparentWhite},0.26);`
    : `background-color:rgba(${theme.colors.transparentBlack},0.08);`};

  > div:first-child {
    width: ${({ progress }) => `${progress}%`};
    height: inherit;
    background-color: ${({ theme, isInverted }) => isInverted ? theme.colors.white : theme.colors.grey15};
  }
`;
